module.exports = "/_next/static/images/flower-5e273bf80124e4efa85d8d8f2da7a2a2.png";